<template>
    <v-alert
        v-if="sendingBulkMessagesDisabledInProvision"
        color="red lighten-4"
        elevation="2"
        icon="mdi-alert-octagon-outline"
        prominent
    >
        {{ sendingBulkMessagesDisabledInProvisionMessage }}
    </v-alert>
</template>

<script>
export default {
    name: 'ProvisionWarningBulkMessages',

    data() {
        return {
        }
    },

    mounted() {
    },

    methods: {
    },

    computed: {
        sendingBulkMessagesDisabledInProvisionMessage()
        {
            return this.$rc.$state.profile?.provision_info?.bulk_message_send_disabled_message;
        },

        sendingBulkMessagesDisabledInProvision() {
            return this.sendingBulkMessagesDisabledInProvisionMessage != null;
        }
    }
}
</script>

<style lang="scss" scoped>
.nudge-up {
    padding-bottom: 2px;
}
</style>